// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Validate required Firebase configuration
if (!firebaseConfig.projectId) {
  throw new Error(
    'Missing required Firebase configuration: REACT_APP_FIREBASE_PROJECT_ID. ' +
    'Please ensure all Firebase environment variables are set with REACT_APP_ prefix.'
  );
}

// Firebase Messaging requires Service Workers, IndexedDB, PushManager, and specific
// prototype members. This mirrors the sync check Firebase performs inside getMessaging()
// so that in-app browsers (Instagram WKWebView, etc.) are excluded before any Firebase
// call is attempted, preventing messaging/unsupported-browser errors.
function isMessagingSupported() {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  if (!('serviceWorker' in navigator)) return false;
  if (typeof indexedDB === "undefined") return false;
  if (!window.isSecureContext) return false;
  if (!('PushManager' in window)) return false;
  if (typeof Notification === "undefined") return false;
  if (typeof fetch === "undefined") return false;
  if (
    typeof ServiceWorkerRegistration !== "undefined" &&
    !('showNotification' in ServiceWorkerRegistration.prototype)
  ) return false;
  if (
    typeof PushSubscription !== "undefined" &&
    !('getKey' in PushSubscription.prototype)
  ) return false;
  return true;
}

// Initialize Firebase app (always safe)
const app = initializeApp(firebaseConfig);

// Only initialize Messaging when the browser supports it (avoids errors in Instagram etc.)
let messaging = null;

const tryInitMessaging = () => {
  if (messaging) {
    return messaging;
  }
  if (!isMessagingSupported()) {
    return null;
  }
  try {
    messaging = getMessaging(app);
  } catch (error) {
    if (typeof console !== "undefined") {
      console.warn("pushNotification >> getMessaging failed.", error);
    }
  }
  return messaging;
};

tryInitMessaging();

/** Re-attempt getMessaging on demand — module load can run before IndexedDB is usable on cold tabs. */
export const resolveMessaging = () => tryInitMessaging();